import * as types from "./actionTypes";
import { setSnackBar } from "./snackBarActions";
import { SnackBarProps } from "../../Utils/SnackBarUtils";

export function dispatchActionData(type, data) {
  return { type: type, data: data };
}

//updating files status
export function updateFileReviewStatus(data) {
  return async function (dispatch) {
    try {
      await dispatch(dispatchActionData(types.UPDATE_FILE_REVIEW_STATUS, data));
      const snackBarMsg = data.fileName + " status updated to " + data.status;
      const snackBarObj = new SnackBarProps(snackBarMsg, "success");
      dispatch(setSnackBar(snackBarObj));
    } catch (error) {
      console.log("error updating file status " + error.response);
    }
  };
}
